import React from 'react';
import { Chip, ChipProps } from '@mui/material';

type StatusChipProps = Pick<ChipProps, 'label' | 'color' | 'onClick'> & { filterActive?: boolean };

/** Shared visual treatment for business status labels. */
const StatusChip: React.FC<StatusChipProps> = ({ label, color = 'default', onClick, filterActive }) => (
  <Chip
    label={label}
    color={color}
    size="small"
    variant="outlined"
    onClick={onClick}
    aria-pressed={onClick ? Boolean(filterActive) : undefined}
    sx={{ height: 24, borderRadius: 1, flexShrink: 0, fontWeight: 700, bgcolor: filterActive ? 'action.selected' : undefined }}
  />
);

export default StatusChip;
